import { render, staticRenderFns } from "./CardPacienteAgenda.vue?vue&type=template&id=503b3a08&scoped=true"
import script from "./CardPacienteAgenda.vue?vue&type=script&lang=js"
export * from "./CardPacienteAgenda.vue?vue&type=script&lang=js"
import style0 from "./CardPacienteAgenda.vue?vue&type=style&index=0&id=503b3a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503b3a08",
  null
  
)

export default component.exports